import type { FaireProductEntity } from "../../entity_types/product";

export const p_a7jbrhemyc: FaireProductEntity = {
  token: "p_a7jbrhemyc",
  type: "product",
  name: "Goodnight Moon Board Book: Margaret Wise Brown  Clement Hurd",
  brandToken: "b_brkasb91",
  brandName: "HarperCollins",
  imageUrl:
    "https://cdn.faire.com/fastly/db7dbb8a5e24a3d3388dd09a65b6ada6cb7db749de9605f67ffb095fd0d9d6a5.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.5,
  description:
    "Margaret Wise Brown, Clement Hurd (Illustrated by)\nBoard Book  | 34 pages\nJuvenile Fiction / Animals / Rabbits\n\nGeneration after generation, young readers have fallen in love with Margaret Wise Brown and Clement Hurd’s comforting story of a little bunny saying goodnight to all of the familiar things in his room. With a burst on the jacket in celebration of its 60th anniversary, this well-loved board book classic is guaranteed to capture the hearts of a whole new generation of our youngest readers.\n\nMargaret Wise Brown and Clement Hurd, one of the most popular author-and-illustrator teams in children’s book history, created a lasting magic with their quiet poetry and gentle illustrations.",
  tags: [],
  msrpDollars: 10.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:58.699Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
